import { render } from "./ContactDashboard.vue?vue&type=template&id=0617d77b"
import script from "./ContactDashboard.vue?vue&type=script&lang=js"
export * from "./ContactDashboard.vue?vue&type=script&lang=js"

import "./ContactDashboard.vue?vue&type=style&index=0&id=0617d77b&lang=css"

import exportComponent from "/Users/abayomi/IdeaProjects/microservice-2/harvest-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__